import createVueI18nInstance from "@rmp/core/plugins/i18n";
import locales from "@rmp/id/plugins/i18n/locales";

const i18n = createVueI18nInstance(locales);
export default i18n;
